// extracted by mini-css-extract-plugin
module.exports = {"component":"_2H6Jg54-T3nipZ3rWUdfGd","icon":"_2Sb1F-LOMuWknflhJAGhV_","whiteOffline":"_1N0flNgqnYuPJutmPE1DRQ","online":"_3DuLK7ZXd5yz7pkXQ4VWbf","away":"_26LDfbPVSRDUuPnMxpZLPQ"};